"use client";
import "./homeTrustBar.css";
import { motion } from "framer-motion";
import { useTranslations } from "next-intl";
import { fadeUp } from "@lib/motion";

const ITEMS = ["independent", "evaluated", "personalized", "noSponsored", "tracking"] as const;

// Repeat the run enough times that the loop stays seamless on wide screens.
const COPIES = 4;

export default function HomeTrustBar() {
  const t = useTranslations("home.trust");

  return (
    <motion.div id="home-trust-bar" className="home-trust-bar" {...fadeUp()}>
      <div className="home-trust-track">
        {Array.from({ length: COPIES }).map((_, copy) => (
          <div key={copy} className="home-trust-group" aria-hidden={copy > 0}>
            {ITEMS.map((key) => (
              <span key={key} className="home-trust-item">
                <span className="home-trust-dot" aria-hidden="true" />
                {t(key)}
              </span>
            ))}
          </div>
        ))}
      </div>
    </motion.div>
  );
}
